<template>
    <div class="block block-quote">
        <div class="capper">
            <div class="capper-padded-4x">
                <div class="quote" v-html="formatQuote"></div>
            </div>
        </div>
    </div>
</template>
<script>
import gh from '@/helpers/gh'
export default {
    name: "QuoteBlock",
    props: {
        json: {
            type: Object,
            required: true,
        },
        allJson: {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            gh: gh
        }
    },
    computed: {
        formatQuote() {
            let txt = gh.removeTags(this.json.quote)
            txt = '“' + txt + '”'
            return txt
        }
    }

}
</script>